
import { colors } from '../Token/token';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { CreateElement } from 'vue';
import { VARIANTS, TEXT_TAGS, INKS } from './TextStyle';

/**
 * Text Component.
 *
 * Typography collection.
 */
export default Vue.extend({
  name: 'WebText',
  props: {
    /**
     * Tag HTML of the text.<br />
     * Eg: `p`, `label`, `h1`
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Text variant.<br />
     * Possible value: `primary-text` | `secondary-text` | `body-text` | `secondary-body-text` |
     * `primary-dark` | `body1` | `body2` | `button` | `overline` | `hero` | `display` | `headline` |
     * `title-1` | `title-2` | `title-3` | `ui-huge` | `ui-large` | `ui-baseline` | `ui-small` |
     * `ui-tiny` | `caption-tiny` | `caption-micro`
     */
    variant: {
      type: String,
      default: null
    },
    /**
     * Text ink variant
     * Possible value: `white` | `highlight` | `label` | `alert` | `warning` | `positive` | `price` |
     * `primary` | `grayscale` | `secondary` | `muted` | `primary-interactive` | `destructive-interactive` |
     * `gray-warm` | `midnight` | `gray-raven`
     */
    ink: {
      type: String,
      default: null
    },
    /**
     * Make text bold.
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Make text align center horizontally.
     */
    center: {
      type: Boolean,
      default: false
    },
    /**
     * Make text align right.
     */
    right: {
      type: Boolean,
      default: false
    },
    /**
     * Make text align left.
     */
    left: {
      type: Boolean,
      default: false
    },
    /**
     * Make text to UPPERCASE.
     */
    upperCase: {
      type: Boolean,
      default: false
    },
    /**
     * Make text to lowercase.
     */
    lowerCase: {
      type: Boolean,
      default: false
    },
    /**
     * Make text underlined.
     */
    linkStyle: {
      type: Boolean,
      default: false
    }
  },
  render(h: CreateElement) {
    let style: { [key: string]: any } = {
      color: INKS[this.ink] || null
    };
    if (this.bold) {
      style.fontWeight = '700';
    }
    if (this.center) {
      style.textAlign = 'center';
    }
    if (this.right) {
      style.textAlign = 'right';
    }
    if (this.left) {
      style.textAlign = 'left';
    }
    if (this.upperCase) {
      style.textTransform = 'uppercase';
    }
    if (this.lowerCase) {
      style.textTransform = 'lowercase';
    }
    if (this.linkStyle) {
      style.textDecoration = 'underline';
      style.cursor = 'pointer';
    }
    return h(
      this.tag || 'div',
      {
        class: {
          [this.variant]: true
        },
        style,
        attrs: {
          ...this.$attrs
        }
      },
      [
        /**
         * @slot Content of text
         */
        this.$slots.default
      ]
    );
  }
});
